import { useState, useMemo, useCallback } from 'react';

export const useSalesFinances = ({ cartItems }) => {
    const [payments, setPayments] = useState([]);
    const [discount, setDiscount] = useState('');

    const handleAddPayment = useCallback((payment) => {
        setPayments(prev => [...prev, {
            ...payment,
            id: Date.now(),
            value: parseFloat(payment.value) || 0
        }]);
    }, []);

    const handleRemovePayment = useCallback((id) => {
        setPayments(prev => prev.filter(p => p.id !== id));
    }, []);

    const totals = useMemo(() => {
        const subtotal = cartItems.reduce((acc, curr) => acc + (parseFloat(curr.totalPrice || curr.price) || 0), 0);
        const totalWithDiscount = Math.max(0, subtotal - (parseFloat(discount) || 0));
        const totalPaid = payments.reduce((acc, curr) => acc + (parseFloat(curr.value) || 0), 0);
        const balance = Math.max(0, totalWithDiscount - totalPaid);
        const surplus = Math.max(0, totalPaid - totalWithDiscount);
        return { subtotal, discount: parseFloat(discount) || 0, total: totalWithDiscount, totalPaid, balance, surplus };
    }, [cartItems, payments, discount]);

    return { payments, handleAddPayment, handleRemovePayment, discount, setDiscount, totals };
};
